<script setup>
defineProps({
  blocco: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<template>
  <div class="primo-blocco">
    <div class="row-400-20 p-bot-1 max">
      <div class="main-section">
        <!-- eslint-disable vue/no-v-html -->
        <h2
          v-if="blocco.titolo"
          class="heading-1 intro-page"
          v-html="blocco.titolo"
        />
        <div
          v-if="blocco.testo"
          class="m-top-3 text-2 testo-blocco"
          v-html="blocco.testo"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroPagine',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
